import React, {Component} from 'react';
import 'assets/sass/common/InputEmail.scss';

export class InputEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            isValid: false,
            isFilled: false,
            isFocus: false

        };
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleFocus() {
        this.setState({hasError: false, isValid: false});
    }

    handleBlur(event) {
        const value = event.target.value;
        if (value.length !== 0) {
            this.setState({isFilled: true});
            this.checkEmail(value);
        } else {
            this.setState({isFilled: false, isValid: false});
        }
    }

    checkEmail(value) {
        let isValid = false;
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(value)) {
            isValid = true;
        }
        this.setState({isValid: isValid, hasError: !isValid});
    }

    classNames() {
        let thereIsAnError = this.state.hasError || this.props.errorMessage;
        return 'input-email ' +
            (this.state.isFilled ? ' filled' : '') +
            (this.state.isValid && !thereIsAnError ? ' valid' : '') +
            (thereIsAnError ? ' error' : '');
    }

    render() {
        return (
            <div className={this.classNames()}>
                <input type="email" name="email" placeholder={this.props.placeholder} onChange={this.props.onChange}
                       onBlur={this.handleBlur} onFocus={this.handleFocus} defaultValue={this.props.defaultValue}
                       autoComplete="username"/>
                <div className="input-label">{this.props.label}</div>
                <div className="input-email-error">{this.props.errorMessage || "Email incorrecto"}</div>
                <div className="input-email-icon-error"></div>
                <div className="input-email-icon-valid"></div>
            </div>
        );
    }
}
